export const PLACEMENTS_2_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Placement Partners",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "image 1",
    meta_priority: 1,
  },

  PLACEMENTS_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #222222)",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #222222)",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_color",
      label: "Title Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Button Text",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button text color (e.g., #222222)",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "scroll_frequency",
      label: "Scroll Frequency",
      description:
        "Higher value = slower scroll, lower value = faster scroll. To slow the carousel down, increase this number. Default: 3000.",
      value: "3000",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Scroll Frequency (e.g., 3000)",
      required: false,
      defaultValue: "3000",
    },
    {
      fieldName: "status",
      label: "Placements Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Placements Section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Image",
      required: false,
    },
    {
      header: "Alt Image",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ],
};
